import classNames from "classnames";
import Avatar from "rivals/components/shared/Avatar";
import {
  AvatarSize,
  AvatarSizeMobile
} from "rivals/components/shared/Avatar/types";
import { MEDIA_BREAKPOINTS } from "rivals/media";
import { AthleteBioVariants } from "rivals/shared/interfaces/Athlete";
import { setData } from "rivals/shared/utils/qa";
import PersonalStats from "./Stats";
import styles from "./index.module.scss";
import { OwnProps } from "./types";

const TeamLogo = ({
  alt = "sm-athlete-team-logo",
  className = "",
  src = ""
}): JSX.Element => {
  return <img alt={alt} className={className} src={src} {...setData(alt)} />;
};

const PlayerPersonalData = ({
  athleteInTransferPortal,
  collegePlayer: {
    profileImageUrl,
    teamLogo,
    college,
    firstName,
    lastName,
    draftStatus,
    height,
    position,
    weight,
    collegeExperience
  },
  variant
}: OwnProps): JSX.Element => {
  // Do not show background image of logo for athletes in the portal
  const shouldShowTeamLogoBackground = !!teamLogo && !athleteInTransferPortal;
  // Possible classNames include 'cardVariant' or 'pageVariant'
  const containerClassNames = classNames(styles.personalDataContainer, {
    [styles[`${variant}Variant`]]: variant
  });
  let iconSize: AvatarSize = 142;
  let iconSizeMobile: AvatarSizeMobile = 142;
  if (variant === AthleteBioVariants.PAGE) {
    // eslint-disable-next-line no-magic-numbers
    iconSize = 200;
  }
  if (variant === AthleteBioVariants.SOCIAL_CARD) {
    // eslint-disable-next-line no-magic-numbers
    iconSize = 240;
    // eslint-disable-next-line no-magic-numbers
    iconSizeMobile = 86;
  }

  return (
    <>
      {variant == AthleteBioVariants.PAGE && (
        <h1 className={styles.mobileName} title={`${firstName} ${lastName}`}>
          {firstName} {lastName}
        </h1>
      )}
      <div className={containerClassNames}>
        <div className={styles.imageContainer}>
          <Avatar
            alt={"athlete profile"}
            mobileBreakpoint={MEDIA_BREAKPOINTS.MD}
            mobileSize={iconSizeMobile}
            philter={"athlete-profile"}
            priority
            size={iconSize}
            url={profileImageUrl}
          />
          {!!teamLogo && (
            <TeamLogo className={styles.teamLogo} src={teamLogo} />
          )}
        </div>
        <div className={styles.info} {...setData("athlete-profile-info")}>
          <h1
            className={styles.name}
            title={`${firstName} ${lastName}`}
            {...setData("athlete-profile-player-name")}
          >
            {firstName}
            {variant === AthleteBioVariants.SOCIAL_CARD ? <br /> : " "}
            {lastName}
          </h1>
          <PersonalStats
            collegeExperience={collegeExperience}
            collegeName={college.commonName}
            draftStatus={draftStatus}
            height={height}
            positionName={position.name}
            variant={variant}
            weight={weight}
          />
          {shouldShowTeamLogoBackground && (
            <TeamLogo
              alt="bg-athlete-team-logo"
              className={styles.teamLogoBg}
              src={teamLogo}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default PlayerPersonalData;
